var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.2077 8C16.9224 8.06133 18.3784 9.34744 18.3316 11.0703C18.3207 11.4711 18.1654 11.9665 17.8548 12.9574C17.1075 15.342 15.8515 17.412 13.0378 17.9087C12.5206 18 11.9386 18 10.7746 18H9.2241C8.0601 18 7.4781 18 6.96088 17.9087C4.14717 17.412 2.89117 15.342 2.14382 12.9574C1.83328 11.9665 1.67801 11.4711 1.66712 11.0703C1.62028 9.34744 3.07627 8.06133 4.79102 8",
    stroke: "#3A86DD",
    strokeWidth: 1.25,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99935 12.1667V3M9.99935 12.1667C9.41585 12.1667 8.32562 10.5048 7.91602 10.0833M9.99935 12.1667C10.5828 12.1667 11.6731 10.5048 12.0827 10.0833",
    stroke: "#3A86DD",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.9fe7e13813e34add33ae313e786aa572.svg";
export { ForwardRef as ReactComponent };